var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.logado)?_c('v-app',[_c('router-view',{attrs:{"name":"rotas-deslogado"}}),_c('Toast')],1):_c('v-app',[_c('Menu'),_vm._v(" "),_c('Header'),_c('Container',[_c('Toast'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }